import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { WorkspaceId } from '@/domain/types';

interface WorkspaceState {
  workspaceId: WorkspaceId;
  setWorkspace: (workspaceId: WorkspaceId) => void;
}

/** Which workspace the console is looking at. Pages read data through useCurrentWorkspace. */
export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      workspaceId: 'personal',
      setWorkspace: (workspaceId) => set({ workspaceId }),
    }),
    { name: 'latisent-workspace' },
  ),
);
